<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoshow textSelect' ref="commonClientinfoshow">
    <div class="showBox" v-if="!isShowModifyBox && !isSearchLoading">
      <table class="table">
        <tr v-if="info.type!=='1'">
          <td><span>状态：</span>{{info.duty_status_title}}</td>
          <td v-if="info.is_protect==='1'"><span>长期：</span>长期</td>
          <td v-else><span>长期：</span>非长期</td>
        </tr>
        <tr>
          <td><span>来源：</span>{{info.source_id_title}}</td>
          <td><span>等级：</span>{{info.duty_level_title}}</td>
        </tr>
        <tr v-if="info.type!=='1'">
          <td><span>权属人：</span>{{info.duty_uid_user}}</td>
          <td>
            {{info.duty_time_str}}
          </td>
        </tr>
        <tr>
          <td><span>创建人：</span>{{info.adduid_user}}</td>
          <td>
            {{info.addtime_str}}
          </td>
        </tr>
        <tr>
          <td colspan="2"><span>所属部门：</span>{{info.sectionid_title}}</td>
        </tr>
      </table>
      <table class="table ">
        <tr>
          <td>
            <div class="flex">
              <span>意向国家：</span><div>{{info.is_country_str}}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="flex">
              <span>意向项目：</span><div>{{info.is_items_str}}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="flex">
              <span>意向签证：</span><div>{{info.is_visa_str}}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="flex">
              <span>独属标签：</span>
              <div>{{info.selftages_str}}</div>
            </div>
          </td>
        </tr>
      </table>
      <table class="table ">
        <tr>
          <td><span>名称：</span>{{info.user}}</td>
          <td><span>编号：</span>{{info.token}}</td>
        </tr>
        <tr>
          <td><span>联系人：</span>{{info.name}}</td>
          <td v-if="info.phone">
            <span>电话：</span>
            <u style="height:16px;display: inline-block;" ref="phoneNode">******
              <a v-if="(info.type==='2' && rbacCrmhopeViewContact) || (info.type==='3' && rbacCrmsignViewContact)" title="此为日志行为" @click="viewContact(info.id,'phone')" class="link">查看</a>
            </u>
          </td>
          <td v-else><span>电话：</span></td>
        </tr>
        <tr>
          <td><span>性别：</span>{{info.sex==='1'?'男':'女'}}</td>
          <td><span>婚姻：</span>{{info.marriage}}</td>
        </tr>
        <tr>
          <td><span>年龄：</span>{{info.age}}</td>
          <td><span>类型：</span>{{info.business_id_title}}</td>
        </tr>
        <tr>
          <td v-if="info.landline">
            <span>固话：</span>
            <u style="height:16px;display: inline-block;" ref="landlineNode">******
              <a v-if="(info.type==='2' && rbacCrmhopeViewContact) || (info.type==='3' && rbacCrmsignViewContact)" title="此为日志行为" @click="viewContact(info.id,'landline')" class="link">查看</a>
            </u>
          </td>
          <td v-else><span>固话：</span></td>
          <td><span>QQ：</span>{{info.qq}}</td>
        </tr>
        <tr>
          <td v-if="info.wechat">
            <span>微信：</span>
            <u style="height:16px;display: inline-block;" ref="wechatNode">******
              <a v-if="(info.type==='2' && rbacCrmhopeViewContact) || (info.type==='3' && rbacCrmsignViewContact)" title="此为日志行为" @click="viewContact(info.id,'wechat')" class="link">查看</a>
            </u>
          </td>
          <td v-else><span>微信：</span></td>
          <td><span>微博：</span>{{info.weibo}}</td>
        </tr>
        <tr>
          <td><span>邮箱：</span>{{info.email}}</td>
          <td><span>邮编：</span>{{info.postcode}}</td>
        </tr>
        <tr>
          <td><span>公司：</span>{{info.company}}</td>
          <td><span>职位：</span>{{info.position}}</td>
        </tr>
        <tr>
          <td><span>律所：</span>{{info.attorney_title}}</td>
          <td><span>学历：</span>{{info.education}}</td>
        </tr>
        <tr>
          <td><span>英语：</span>{{info.elevel}}</td>
          <td><span>资产：</span>{{info.asset}}</td>
        </tr>
        <tr>
          <td><span>地区：</span>{{info.city_name}}</td>
          <td colspan="2"><span>移民目的：</span>{{info.aim}}</td>
        </tr>
        <tr>
          <td colspan="2"><span>家庭地址：</span>{{info.address}}</td>
        </tr>
        <tr>
          <td colspan="2"><span>通讯地址：</span>{{info.tx_address}}</td>
        </tr>
        <tr>
          <td colspan="2"><span>客户备注：</span>{{info.content}}</td>
        </tr>
      </table>
      <table class="table ">
        <tr>
          <td><span>推荐人编号：</span>{{info.ttoken}}</td>
          <td><span @click="viewGuanxitupuFun" class="text-primary cursor" style="text-decoration: underline">点击查看关系图谱</span></td>
        </tr>
      </table>
      <br><br>
      <span v-if="info.type!=='1' && info.is_del!=='1'" @click="modifyBoxFun(true)" class="tianjia btn btn-success btn-round">修改</span>
    </div>
    <div class="showModify" v-if="isShowModifyBox">
      <div class="text-left description">注：电话/微信/固话默认为“*”时将保持原内容不做修改</div>
      <hr>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">客户</span>
            </div>
            <input type="text" placeholder="必填" class="form-control" v-model="user">
          </div>
        </div>
        <div class="b">
          <multiselect v-model="sectionVal" track-by="name" label="name" placeholder="所属部门 - 必选" :options="sectionArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">联系人</span>
            </div>
            <input type="text" class="form-control" placeholder="必填" v-model="name">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">手机号</span>
            </div>
            <input type="text" class="form-control" v-model="phone" :disabled="((info.type==='2' && !rbacCrmhopeUpdateContact) || (info.type==='3' && !rbacCrmsignUpdateContact)) && info.phone!==''">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <multiselect v-model="businessVal" track-by="name" label="name" placeholder="客户类型 - 必选" :options="businessArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
        </div>
        <div class="b">
          <multiselect v-model="sourceVal" track-by="name" label="name" placeholder="客户来源 - 必选" :options="sourceArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a" v-if="info.type!=='1'">
          <multiselect v-model="statusVal" track-by="name" label="name" placeholder="客户状态 - 必选" :options="statusArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
        </div>
        <div class="b">
          <multiselect v-model="levelVal" track-by="name" label="name" placeholder="客户等级" :options="levelArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
        </div>
      </div>
      <div class="box">
        <hr>
      </div>
      <div class="box imgBox mb-3">
        <vue-core-image-upload
          :crop="false"
          :inputOfFile="'UploadFormfile[imgFile]'"
          @imageuploaded="imageuploaded"
          @imagechanged="imagechanged"
          @imageuploading='imageuploading'
          @errorhandle='errorhandle'
          inputAccept='image/jpg,image/jpeg,image/png'
          :maxFileSize='uploadSize'
          input-of-file="file"
          :data="{dir:'head'}"
          :headers="{Authorization:localUser.token}"
          :url="uploadUrl">
          <img v-if="headpath" :src="headpath" class='img-thumbnail' >
          <img v-else src="/static/images/uploadTupian.png">
        </vue-core-image-upload>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <multiselect v-model="selftagesVal" :hideSelected="true" :options="selftagesArr" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="独属标签" label="name" track-by="id">
            <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="selftagesVal.length &amp;&amp; !isOpen">{{selftagesValStr}}</span>
            </template>
          </multiselect>
        </div>
        <div class="b">
          <multiselect v-model="itemsVal" :hideSelected="true" :options="itemsArr" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="意向项目" label="name" track-by="id">
            <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="itemsVal.length &amp;&amp; !isOpen">{{itemsValStr}}</span>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <multiselect v-model="visaVal" :hideSelected="true" :options="visaArr" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="意向签证" label="name" track-by="id">
            <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="visaVal.length &amp;&amp; !isOpen">{{visaValStr}}</span>
            </template>
          </multiselect>
        </div>
        <div class="b">
          <multiselect v-model="countryVal" :hideSelected="true" :options="countryArr" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="意向国家" label="name" track-by="id">
            <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="countryVal.length &amp;&amp; !isOpen">{{countryValStr}}</span>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="box">
        <hr>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">微信</span>
            </div>
            <input type="text" class="form-control" v-model="wechat" :disabled="((info.type==='2' && !rbacCrmhopeUpdateContact) || (info.type==='3' && !rbacCrmsignUpdateContact)) && info.wechat!==''">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">微博</span>
            </div>
            <input type="text" class="form-control" v-model="weibo">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">邮箱</span>
            </div>
            <input type="text" class="form-control" v-model="email">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">固话</span>
            </div>
            <input type="text" class="form-control" v-model="landline" :disabled="((info.type==='2' && !rbacCrmhopeUpdateContact) || (info.type==='3' && !rbacCrmsignUpdateContact)) && info.landline!==''">
          </div>
        </div>
      </div>
      <div class="box mb-3">
          <multiselect v-model="cityVal" track-by="name" label="name" placeholder="城市" :options="cityArr" :searchable="true"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">QQ</span>
            </div>
            <input type="text" class="form-control" v-model="qq">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">年龄</span>
            </div>
            <input type="text" class="form-control" v-model="age">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">婚姻</span>
            </div>
            <input type="text" class="form-control" v-model="marriage">
          </div>
        </div>
        <div class="b">
          <multiselect v-model="sexVal" track-by="name" label="name" placeholder="性别" :options="sexArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">公司</span>
            </div>
            <input type="text" class="form-control" v-model="company">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">职位</span>
            </div>
            <input type="text" class="form-control" v-model="position">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">邮编</span>
            </div>
            <input type="text" class="form-control" v-model="postcode">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">学历</span>
            </div>
            <input type="text" class="form-control" v-model="education">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">英语水平</span>
            </div>
            <input type="text" class="form-control" v-model="elevel">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">家庭资产</span>
            </div>
            <input type="text" class="form-control" v-model="asset">
          </div>
        </div>
      </div>

      <div class="box tow mb-3">
        <div class="a">
          <multiselect v-model="attorneyVal" track-by="name" label="name" placeholder="合作律所" :options="attorneyArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">移民目的</span>
            </div>
            <input type="text" class="form-control" v-model="aim">
          </div>
        </div>
      </div>
      <div class="box mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">家庭住址</span>
          </div>
          <input type="text" class="form-control" v-model="address">
        </div>
      </div>
      <div class="box mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">通讯住址</span>
          </div>
          <input type="text" class="form-control" v-model="tx_address">
        </div>
      </div>
      <div class="box mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">客户备注</span>
          </div>
          <input type="text" class="form-control" v-model="content">
        </div>
      </div>
      <hr>
      <div class="box mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">推荐人编号</span>
          </div>
          <input type="text" class="form-control" v-model="ttoken">
        </div>
      </div>
      <div class="box mb-3 text-center">
        <button @click="modifyBoxFun(false)" type="button" class="btn btn-light btn-round">取消</button>
        <button @click="submitFun()" type="button" class="btn btn-success btn-round"><i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> 修改</button>
      </div>
    </div>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import rbacMix from '@/util/mix/localUserMix';
import { mapGetters } from 'vuex';
import * as types from '@/store/types';
import VueCoreImageUpload from 'vue-core-image-upload';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { EventBus } from '@/util/eventBus';
import resultCommons from '@/util/resultcommons';
import commons from '../../../util/commons';

export default {
  name: 'commonClientinfoshow',
  mixins: [rbacMix],
  props: ['info', 'token', 'pInitDataInfo', 'rootUnitIsSuccessFun', 'isRbac'],
  data() {
    return {
      uploadUrl: process.env.IMAGE_UPLOAD_URL, // 图片上传地址
      uploadSize: process.env.IMAGE_UPLOAD_SIZE, // 图片上传大小

      isShowModifyBox: false,
      isSubmitLoading: false,
      // 加载中
      isSearchLoading: true,


      headpath: '',
      // 客户
      user: '',
      // 部门
      sectionVal: null,
      // 联系人
      name: '',
      // 联系电话
      phone: '',
      // 客户类型
      businessVal: null,
      // 来源
      sourceVal: null,
      // 客户类型
      statusVal: null,
      // 客户类型
      levelVal: null,

      // 客户标签
      selftagesVal: [],
      // 项目
      itemsVal: [],
      // 签证
      visaVal: [],
      // 国家
      countryVal: [],
      // 微信
      wechat: '',
      // 微博
      weibo: '',
      // 邮箱
      email: '',
      // 固话
      landline: '',
      // 客户类型
      cityVal: null,
      // qq
      qq: '',
      // 年龄
      age: '',
      // 婚姻
      marriage: '',
      // 性别
      sexVal: null,
      // 公司
      company: '',
      // 职位
      position: '',
      // 邮编
      postcode: '',
      // 教育程度
      education: '',
      // 英语水平
      elevel: '',
      // 家庭资产
      asset: '',
      // 合作律所
      attorneyVal: null,
      // 移民目的
      aim: '',
      // 家庭地址
      address: '',
      // 通讯地址
      tx_address: '',
      // 客户备注
      content: '',
      ttoken: '',

      // 部门
      sectionArr: [
        { name: '网络部', id: '1' },
        { name: '咨询部', id: '2' },
      ],
      // 来源
      sourceArr: [
        { name: '渠道介绍', id: '1' },
        { name: '网络拓客', id: '2' },
      ],
      // 类型
      businessArr: [
        { name: '移民', id: '1' },
        { name: '留学', id: '2' },
      ],
      // 状态
      statusArr: [
        { name: '有效', id: '1' },
        { name: '等级', id: '2' },
      ],
      // 等级
      levelArr: [
        { name: '一般客户', id: '1' },
        { name: '重点客户', id: '2' },
      ],
      // 等级
      cityArr: [
        { name: '合肥市', id: '1' },
        { name: '长沙市', id: '2' },
      ],
      // 合作律所
      attorneyArr: [
        { name: '美国律所', id: '1' },
        { name: '加拿大律所', id: '2' },
      ],
      // 性别
      sexArr: [
        { name: '男', id: '1' },
        { name: '女', id: '0' },
      ],
      // 签证
      visaArr: [
        { name: '签证A', id: '1' },
        { name: '签证B', id: '2' },
      ],
      // 国家
      countryArr: [
        { name: '国家A', id: '1' },
        { name: '国家B', id: '2' },
      ],
      // 项目
      itemsArr: [
        { name: '项目A', id: '1' },
        { name: '项目B', id: '2' },
      ],
      // 标签
      selftagesArr: [
        { name: 'EB-51', id: '1' },
        { name: '小签证2', id: '2' },
        { name: '小签证3', id: '3' },
        { name: '小签证4', id: '4' },
        { name: '小签证5', id: '5' },
        { name: '小签证6', id: '6' },
        { name: '小签证7', id: '7' },
        { name: '小签证8', id: '8' },
        { name: '小签证9', id: '9' },
        { name: '小签证10', id: '10' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      localUser: types.GET_LOCALUSER,
    }),
    // 选中的签证
    visaValStr() {
      const arr = [];
      this.visaVal.forEach((app) => {
        arr.unshift(app.name);
      });
      return arr.join(',');
    },
    // 选中的国家
    countryValStr() {
      const arr = [];
      this.countryVal.forEach((app) => {
        arr.unshift(app.name);
      });
      return arr.join(',');
    },
    // 选中的项目
    itemsValStr() {
      const arr = [];
      this.itemsVal.forEach((app) => {
        arr.unshift(app.name);
      });
      return arr.join(',');
    },
    // 标签
    selftagesValStr() {
      const arr = [];
      this.selftagesVal.forEach((app) => {
        arr.unshift(app.name);
      });
      return arr.join(',');
    },
    dataJson() {
      return {
        headpath: this.headpath,
        type: this.info.type,
        token: this.info.id,
        user: this.user,
        sectionid: commons.whereArrStr(this.sectionVal),
        name: this.name,
        phone: this.phone,
        business_id: commons.whereArrStr(this.businessVal),
        source_id: commons.whereArrStr(this.sourceVal),
        duty_status: commons.whereArrStr(this.statusVal),
        duty_level: commons.whereArrStr(this.levelVal),
        selftages: commons.whereArrStr(this.selftagesVal),
        is_items: commons.whereArrStr(this.itemsVal),
        is_visa: commons.whereArrStr(this.visaVal),
        is_country: commons.whereArrStr(this.countryVal),
        wechat: this.wechat,
        weibo: this.weibo,
        email: this.email,
        landline: this.landline,
        city: commons.whereArrStr(this.cityVal),
        qq: this.qq,
        age: this.age,
        marriage: this.marriage,
        sex: commons.whereArrStr(this.sexVal),
        company: this.company,
        position: this.position,
        postcode: this.postcode,
        education: this.education,
        elevel: this.elevel,
        asset: this.asset,
        attorney: commons.whereArrStr(this.attorneyVal),
        aim: this.aim,
        address: this.address,
        tx_address: this.tx_address,
        content: this.content,
        ttoken: this.ttoken,
      };
    },
  },
  methods: {
    viewGuanxitupuFun() {
      EventBus.$emit('globalRightBoxFun', { bool: true, compnent: 'ui-client-info-guanxitupu', token: this.token });
    },
    viewContact(id, type) {
      const node = this.$refs[`${type}Node`];
      node.innerHTML = "<i class='iconfont icon-jiazai xuanzhuan' style='font-size: 13px;'></i>";
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      resultCommons.apiCrmviewcontact(this, { token: id, type }).then((ob) => {
        EventBus.$emit('globalZhezhaoBoxFun', false);
        if (ob.state === 200) {
          node.innerHTML = ob.data.contact;
        } else {
          node.innerHTML = '读取失败';
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
        }
      });
    },
    errorhandle(str) {
      // 上传选择后
      this.$message.showMsgBox({
        type: 'danger',
        content: '上传失败',
      });
    },
    imageuploading() {
      // 上传中
    },
    imagechanged(ob) {
      // 选择后
      // this.is_loading = false;
    },
    // 上传成功回调
    imageuploaded(res) {
      if (res.state === 200) {
        // 上传成功不弹框提示
        this.headpath = res.data.path;
      } else {
        this.$message.showMsgBox({
          type: 'danger',
          content: res.message,
        });
      }
    },
    // 切换
    modifyBoxFun(bool) {
      this.$refs.commonClientinfoshow.scrollTop = 0;
      this.isShowModifyBox = bool;
    },
    setInitDataInfo() {
      this.headpath = this.info.photo;
      this.user = this.info.user;
      this.name = this.info.name;
      this.phone = this.info.phone;
      this.wechat = this.info.wechat;
      this.weibo = this.info.weibo;
      this.email = this.info.email;
      this.landline = this.info.landline;
      this.qq = this.info.qq;
      this.age = this.info.age;
      this.marriage = this.info.marriage;
      this.company = this.info.company;
      this.position = this.info.position;
      this.postcode = this.info.postcode;
      this.education = this.info.education;
      this.elevel = this.info.elevel;
      this.asset = this.info.asset;
      this.aim = this.info.aim;
      this.address = this.info.address;
      this.tx_address = this.info.tx_address;
      this.content = this.info.content;
      this.attorneyVal = { id: this.info.attorney, name: this.info.attorney_title };
      this.sexVal = { id: this.info.sex, name: this.info.sex === '1' ? '男' : '女' };
      this.cityVal = { id: this.info.city, name: this.info.city_name };
      this.ttoken = this.info.ttoken;
      // 项目
      if (this.info.is_items) {
        const isItemsIdArr = this.info.is_items.split(',');
        const isItemsNameArr = this.info.is_items_str.split(',');
        const itemsVal = [];
        isItemsIdArr.forEach((app, index) => {
          itemsVal.push({ id: isItemsIdArr[index], name: isItemsNameArr[index] });
        });
        this.itemsVal = itemsVal;
      } else {
        this.itemsVal = [];
      }
      // 签证
      if (this.info.is_visa) {
        const isVisaIdArr = this.info.is_visa.split(',');
        const isVisaNameArr = this.info.is_visa_str.split(',');
        const visaVal = [];
        isVisaIdArr.forEach((app, index) => {
          visaVal.push({ id: isVisaIdArr[index], name: isVisaNameArr[index] });
        });
        this.visaVal = visaVal;
      } else {
        this.visaVal = [];
      }
      // 国家
      if (this.info.is_country) {
        const isCountryIdArr = this.info.is_country.split(',');
        const isCountryNameArr = this.info.is_country_str.split(',');
        const countryVal = [];
        isCountryIdArr.forEach((app, index) => {
          countryVal.push({ id: isCountryIdArr[index], name: isCountryNameArr[index] });
        });
        this.countryVal = countryVal;
      } else {
        this.countryVal = [];
      }
      // 私有标签
      if (this.info.selftages) {
        const selftagesIdArr = this.info.selftages ? this.info.selftages.split(',') : [];
        const selftagesNameArr = this.info.selftages_str ? this.info.selftages_str.split(',') : [];
        const selftagesVal = [];
        selftagesIdArr.forEach((app, index) => {
          selftagesVal.push({ id: selftagesIdArr[index], name: selftagesNameArr[index] });
        });
        this.selftagesVal = selftagesVal;
      } else {
        this.selftagesVal = [];
      }
      // 等级
      this.levelVal = { id: this.info.duty_level, name: this.info.duty_level_title };
      // 状态
      this.statusVal = { id: this.info.duty_status, name: this.info.duty_status_title };
      // 来源
      this.sourceVal = { id: this.info.source_id, name: this.info.source_id_title };
      // 类型
      this.businessVal = { id: this.info.business_id, name: this.info.business_id_title };
      // 部门
      this.sectionVal = { id: this.info.sectionid, name: this.info.sectionid_title };
    },
    apiCrmTages() {
      // 获取的类型(状态/等级)
      const root = this.info.type === '2' ? 2 : 5;
      console.log(root);
      return resultCommons.apiCrmTages(this, { root, city: true }).then((ob) => {
        this.sectionArr = ob.data.bumen;
        this.businessArr = ob.data.leixing;
        this.sourceArr = ob.data.laiyuan;
        this.statusArr = ob.data.zhuangtai;
        this.levelArr = ob.data.dengji;
        this.selftagesArr = ob.data.biaoqian;
        this.itemsArr = ob.data.yimin;
        this.visaArr = ob.data.qianzheng;
        this.countryArr = ob.data.guojia;
        this.cityArr = Object.values(ob.data.city);
      });
    },
    submitFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      this.isSubmitLoading = true;

      if (((this.info.type === '2' && !this.rbacCrmhopeUpdateContact) || (this.info.type === '3' && !this.rbacCrmsignUpdateContact)) && this.info.phone !== '') {
        this.dataJson.phone = this.info.phone;
      }
      if (((this.info.type === '2' && !this.rbacCrmhopeUpdateContact) || (this.info.type === '3' && !this.rbacCrmsignUpdateContact)) && this.info.wechat !== '') {
        this.dataJson.wechat = this.info.wechat;
      }
      if (((this.info.type === '2' && !this.rbacCrmhopeUpdateContact) || (this.info.type === '3' && !this.rbacCrmsignUpdateContact)) && this.info.landline !== '') {
        this.dataJson.landline = this.info.landline;
      }
      resultCommons.apiCrmModify(this, this.dataJson).then((ob) => {
        EventBus.$emit('globalZhezhaoBoxFun', false);
        this.isSubmitLoading = false;
        if (ob.state === 200) {
          // 更新基本信息
          this.pInitDataInfo().then((app) => {
            this.setInitDataInfo();
          });
          this.isShowModifyBox = false;
          this.$refs.commonClientinfoshow.scrollTop = 0;
          this.$message.showMsgBox({
            type: 'success',
            content: ob.message,
          });
          // 更新根目录
          this.rootUnitIsSuccessFun(3, ob.data.dataArrStr);
        } else {
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
        }
      });
    },
  },
  components: {
    Multiselect,
    'vue-core-image-upload': VueCoreImageUpload,
  },
  created() {
    // 标签
    this.apiCrmTages().then((app) => {
      this.isSearchLoading = false;
    });
    this.setInitDataInfo();
    // this.initDataInfo();
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoshow{
  flex: 1;
  overflow-y: auto;
  background: #F6F6F6;
  span.tianjia{
    position: absolute;
    display: inline-block;
    width: 90px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  }
  div.showModify{
    padding: 15px;
    background: #F6F6F6;
    div.box{
      hr{
        background: #FFFFFF;
      }
      input{
        color: #1586FF;
      }
      input[disabled]{
        background:#EEEEEE;
      }
      &.tow{
        display: flex;
        div.a{
          flex: 1;
          margin-right: 20px;
        }
        div.b{
          flex: 1;
        }
      }
    }
    div.imgBox{
      text-align: center;
      background: #FFFFFF;
      border-radius: 5px;
      border: 1px solid rgba(1,1,1,0.1);
      background: url("/static/images/msk_c.png") repeat center center;
      background-size: 40px;
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        max-width: 220px;
        max-height: 150px;
      }
    }
  }
  .showBox{
    padding: 15px;
    table{
      background: #FFFFFF;
      border-radius: 15px;
      overflow: hidden;
      &.table-bordered{
        border-radius: 10px;
      }
      tr{
        &:first-child{
          border: 0;
          td,th{
            border: 0;
          }
        }
        td{
          border-color: #EEEEEE;
          //border: 0;
          span{
            color: #999999;
          }
          div.flex{
            display: flex;
            div{
              flex: 1;
            }
          }
          u{
            .link{
              color: red;
              cursor: help;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/show.vue